type CreditPackKey = 'credits_1000' | 'credits_5000' | 'credits_15000';

export type CreditPackClickEventType =
  | 'user_clicked_buy_credits_1000'
  | 'user_clicked_buy_credits_5000'
  | 'user_clicked_buy_credits_15000';

export function getCreditPackClickEventType(packKey: CreditPackKey): CreditPackClickEventType {
  switch (packKey) {
    case 'credits_1000':
      return 'user_clicked_buy_credits_1000';
    case 'credits_5000':
      return 'user_clicked_buy_credits_5000';
    case 'credits_15000':
      return 'user_clicked_buy_credits_15000';
  }
}
